'use client'

import { useMemo, useState } from 'react'
import { ToolField, ToolResultCard, ToolResultRow, toolFmt, toolNum } from './tool-inputs'

export function StairsCalculatorTool() {
  const [totalRise, setTotalRise] = useState('2700')
  const [targetRiser, setTargetRiser] = useState('175')
  const [tread, setTread] = useState('250')

  const r = useMemo(() => {
    const rise = toolNum(totalRise)
    const risers = Math.max(1, Math.round(rise / Math.max(1, toolNum(targetRiser))))
    const actualRiser = rise / risers
    const treads = risers - 1
    const totalRun = treads * toolNum(tread)
    const stringer = Math.sqrt(rise * rise + totalRun * totalRun) / 1000
    // Comfort/regulation guides: riser 150–200 mm, going 250–320 mm.
    const riserOk = actualRiser >= 150 && actualRiser <= 200
    const treadOk = toolNum(tread) >= 250 && toolNum(tread) <= 320
    return { risers, actualRiser, treads, totalRun, stringer, riserOk, treadOk }
  }, [totalRise, targetRiser, tread])

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Staircase</h2>
          <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
            <ToolField label="Total rise" value={totalRise} onChange={setTotalRise} unit="mm" step="10" hint="Floor to floor" />
            <ToolField label="Target riser" value={targetRiser} onChange={setTargetRiser} unit="mm" step="5" hint="150–200 mm" />
            <ToolField label="Tread (going)" value={tread} onChange={setTread} unit="mm" step="10" hint="250–320 mm" />
          </div>
        </div>
        <p className="text-xs text-slate-500">
          A comfortable stair keeps risers 150–200 mm and the going 250–320 mm. Always check your local
          building regulations for the exact limits.
        </p>
      </div>

      <ToolResultCard title="Your staircase">
        <ToolResultRow label="Number of steps (risers)" value={`${r.risers}`} />
        <ToolResultRow label="Actual riser height" value={`${toolFmt(r.actualRiser, 1)} mm${r.riserOk ? ' ✓' : ' ⚠'}`} />
        <ToolResultRow label="Number of treads" value={`${r.treads}`} />
        <ToolResultRow label={`Total run (going ${r.treadOk ? '✓' : '⚠'})`} value={`${toolFmt(r.totalRun / 1000, 2)} m`} />
        <ToolResultRow label="Stringer length (min)" value={`${toolFmt(r.stringer, 2)} m`} strong />
      </ToolResultCard>
    </div>
  )
}
